"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var mediaQuery_1 = require("../systems/mediaQuery");

var display_1 = require("../systems/display");

var stretch_1 = require("../systems/stretch");

var maxWidth_1 = require("../systems/maxWidth");

var spacing_1 = require("../systems/spacing");

var flexSelf_1 = require("../systems/flexSelf");

var border_1 = require("../systems/border");

var textAlign_1 = require("../systems/textAlign");

var color_1 = require("../systems/color");

var Box = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), function (props) {
  return __assign({}, display_1.default(props), stretch_1.default(props), maxWidth_1.default(props), spacing_1.default(props), textAlign_1.default(props), border_1.default(props), flexSelf_1.default(props), color_1.default(props));
}, function (props) {
  return mediaQuery_1.default(props, [display_1.default, stretch_1.default, maxWidth_1.default, spacing_1.default, border_1.default, flexSelf_1.default, textAlign_1.default, color_1.default]);
});
exports.default = Box;
var templateObject_1;